import {combineReducers} from 'redux'
import contact from "./contact"

const rootReducer = combineReducers({
    contact,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js